export {
	BasicLocalStorage,
	BuiltinPlugin,
	LocalStorageCollection,
	builtins,
	builtins as default,
	recommended,
} from './built-in';
export { EventEmitterPlugin, event } from './event/mod';
export { JsonPlugin, json } from './json/mod';
export { LocalStoragePlugin, localstorage } from './localstorage/mod';
